export default function BeforeAfter() {
  const comparisons = [
    {
      before: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/33cdb9ceb4042a1e7a2fecf35e006c10.jpeg',
      after: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/1d268e7552985a508c0b789d1b62ac83.jpeg',
      duration: '２週間後（4回使用）'
    },
    {
      before: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/33cdb9ceb4042a1e7a2fecf35e006c10.jpeg',
      after: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/ff1c3902d3455b7962d73032ee68d4a5.jpeg',
      duration: '４週間後（8回使用後）'
    }
  ];

  return (
    <section className="py-20 bg-[#F8FBFD]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">実際の変化</h2>
          <p className="text-sm text-gray-400">※個人差があります</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {comparisons.map((comparison, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <div className="grid grid-cols-2 gap-0 items-stretch">
                <div className="relative">
                  <div className="w-full h-full overflow-hidden">
                    <img 
                      src={comparison.before} 
                      alt="使用前"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                
                <div className="relative">
                  <div className="w-full h-full overflow-hidden">
                    <img 
                      src={comparison.after} 
                      alt="使用後"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
              
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center">
                <i className="ri-arrow-right-line text-[#4A90E2] text-xl"></i>
              </div>
              
              <div className="p-4 text-center border-t border-gray-100">
                <p className="text-sm text-gray-600 font-medium">{comparison.duration}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}